// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../features/members/MemberItem.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Card - MemberItem Style */

.user-card-item {
  display: flex;
  align-items: center;
  padding: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  border: 2px solid var(--color-wood-800);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
  transition: all 0.2s ease;
  overflow: visible;
}

.user-card-item:hover {
  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.45);
}

/* Clickable avatar area */
.user-card-clickable {
  display: flex;
  align-items: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}

.user-card-clickable:hover {
  opacity: 0.85;
}

.user-card-clickable:active {
  opacity: 0.65;
}

/* Name clickable area */
.user-card-clickable--name {
  flex: 1;
  min-width: 0;
}

.user-card-clickable--name:hover .member-name {
  text-decoration: underline;
}

/* Info block with name + role text */
.user-card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.user-card-role-text {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

/* Compact action button */
.user-card-action-btn {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 20px;
  border: 2px solid var(--color-wood-700);
  background: #c4a570;
  color: var(--color-wood-900);
  font-size: 13px;
  font-weight: 700;
  font-family: var(--font-heading);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
}

.user-card-action-btn:hover:not(:disabled) {
  background: var(--color-wood-600);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(109, 76, 41, 0.45);
}

.user-card-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Mobile */
@media (max-width: 425px) {
  .user-card-item {
    border-width: 1px;
    border-radius: 10px;
  }

  .user-card-role-text {
    font-size: 10px;
  }

  .user-card-action-btn {
    padding: 4px 10px;
    font-size: 11px;
    border-width: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/UserCard.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAGjC;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,6DAA6D;EAC7D,uCAAuC;EACvC,6CAA6C;EAC7C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* User Card - MemberItem Style */\n@import '../../../features/members/MemberItem.css';\n\n.user-card-item {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  border: 2px solid var(--color-wood-800);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n  transition: all 0.2s ease;\n  overflow: visible;\n}\n\n.user-card-item:hover {\n  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.45);\n}\n\n/* Clickable avatar area */\n.user-card-clickable {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  flex-shrink: 0;\n  transition: opacity 0.15s ease;\n}\n\n.user-card-clickable:hover {\n  opacity: 0.85;\n}\n\n.user-card-clickable:active {\n  opacity: 0.65;\n}\n\n/* Name clickable area */\n.user-card-clickable--name {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-card-clickable--name:hover .member-name {\n  text-decoration: underline;\n}\n\n/* Info block with name + role text */\n.user-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.user-card-role-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n/* Compact action button */\n.user-card-action-btn {\n  flex-shrink: 0;\n  padding: 6px 14px;\n  border-radius: 20px;\n  border: 2px solid var(--color-wood-700);\n  background: #c4a570;\n  color: var(--color-wood-900);\n  font-size: 13px;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n}\n\n.user-card-action-btn:hover:not(:disabled) {\n  background: var(--color-wood-600);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(109, 76, 41, 0.45);\n}\n\n.user-card-action-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Mobile */\n@media (max-width: 425px) {\n  .user-card-item {\n    border-width: 1px;\n    border-radius: 10px;\n  }\n\n  .user-card-role-text {\n    font-size: 10px;\n  }\n\n  .user-card-action-btn {\n    padding: 4px 10px;\n    font-size: 11px;\n    border-width: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
